var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-layout" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("MobileCart", { attrs: { "current-page": _vm.$route.name } }),
      _vm._v(" "),
      _c("ApiErrors"),
      _vm._v(" "),
      _c(
        "MobileModal",
        {
          attrs: { "close-on-overlay": true, "center-content": "" },
          model: {
            value: _vm.checkoutModal,
            callback: function($$v) {
              _vm.checkoutModal = $$v
            },
            expression: "checkoutModal"
          }
        },
        [
          _c(
            "MobileSimpleModalContainer",
            { attrs: { title: "Checkout" } },
            [
              _c("CheckoutModal", {
                attrs: { "show-guest-button": false },
                on: {
                  "create-account": _vm.handleCreateAccount,
                  "guest-checkout": _vm.handleGuestCheckout,
                  "sign-in": _vm.handleSignIn
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/MobileLayout.vue?vue&type=template&id=70371eab&scoped=true&
// module id = null
// module chunks = 